import axios from "axios";

/**
 * Attach JWT to every API request (backend reads the `auth` header).
 * Import this module once at app startup before any API calls are made.
 */
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.auth = token;
  }
  return config;
});

export default axios;
